import { http, HttpResponse } from 'msw'

import { allDeliveryMen } from 'app/mocks/data/users/deliveryMen'

import {
    api,
    isNumeric,
    queryIntoArrayNumber,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersDeliveryManApi } from 'app/utils/users/deliveryMan'

import { DeliveryMenRequest } from 'app/types/users/deliveryMan'

export const getAllDeliveryMen = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.deliveryMen.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managersFilter = searchParams.get(
            searchParametersDeliveryManApi.MANAGERS,
        )

        const lastNameFilter = searchParams.get(
            searchParametersDeliveryManApi.LAST_NAME,
        )

        const firstNameFilter = searchParams.get(
            searchParametersDeliveryManApi.FIRST_NAME,
        )

        const cardNumberFilter = searchParams.get(
            searchParametersDeliveryManApi.CARD_NUMBER,
        )

        const mifareCodeFilter = searchParams.get(
            searchParametersDeliveryManApi.MIFARE_CODE,
        )

        let allDeliveryMenFiltered = allDeliveryMen

        // Manager filter
        if (managersFilter) {
            const managersIds = queryIntoArrayNumber(managersFilter)

            allDeliveryMenFiltered = allDeliveryMenFiltered.filter(
                (deliveryMan) =>
                    deliveryMan.client.some((manager) =>
                        managersIds.includes(manager.id),
                    ),
            )
        }

        // Last name filter
        if (lastNameFilter) {
            allDeliveryMenFiltered = allDeliveryMenFiltered.filter(
                (deliveryMan) =>
                    deliveryMan.last_name
                        .toLowerCase()
                        .includes(lastNameFilter.toLowerCase()),
            )
        }

        // First name filter
        if (firstNameFilter) {
            allDeliveryMenFiltered = allDeliveryMenFiltered.filter(
                (deliveryMan) =>
                    deliveryMan.first_name
                        .toLowerCase()
                        .includes(firstNameFilter.toLowerCase()),
            )
        }

        // Card number filter
        if (cardNumberFilter) {
            allDeliveryMenFiltered = allDeliveryMenFiltered.filter(
                (deliveryMan) =>
                    deliveryMan.card_id
                        .toLowerCase()
                        .includes(cardNumberFilter.toLowerCase()),
            )
        }

        // MIFARE code filter
        if (mifareCodeFilter) {
            allDeliveryMenFiltered = allDeliveryMenFiltered.filter(
                (deliveryMan) =>
                    deliveryMan.serial_number
                        .toLowerCase()
                        .includes(mifareCodeFilter.toLowerCase()),
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allDeliveryMenFiltered.length > limit
                ? offset + limit
                : allDeliveryMenFiltered.length

        const results = allDeliveryMenFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allDeliveryMenFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<DeliveryMenRequest>({
            next,
            results,
        })
    },
)
